module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Home/Towel-0ae7ce19c5a3ff7a972f952dc428ef83e82480198e613b4fbdf7ba721b9ea531.svg";